// src/regl/ReglBuffer.ts
import { gl } from "@antv/l7-core";
import { dataTypeMap, usageMap } from "./constants";
var ReglBuffer = class {
  constructor(reGl, options) {
    this.isDestroyed = false;
    const { data, usage, type } = options;
    this.buffer = reGl.buffer({
      data,
      usage: usageMap[usage || gl.STATIC_DRAW],
      type: dataTypeMap[type || gl.UNSIGNED_BYTE]
      // length: 0,
    });
  }
  get() {
    return this.buffer;
  }
  destroy() {
    if (!this.isDestroyed) {
      this.buffer.destroy();
    }
    this.isDestroyed = true;
  }
  subData({
    data,
    offset
  }) {
    this.buffer.subdata(data, offset);
  }
};
export {
  ReglBuffer as default
};
